let initialState = {
    porezniZakoni: [],
    cached: false
};

export default function porezniZakoniReducer(state = initialState, action) {
    switch (action.type) {
        case 'GET_POREZNI_ZAKONI': {
            return Object.assign({}, state, {
                porezniZakoni: [...action.porezniZakoni],
                cached: true
            });
        }
        default:
            return state;
    }
}
